module.exports = __webpack_public_path__ + "static/media/7@3x.ab916ea6.png";